<template>
	<div class="form-group text-left base-search">
		<select class="browser-default custom-select" v-bind="$attrs" v-model="value.type">
			<option
				v-for="option in options"
				:key="option"
				:value="option"
				:selected="option === value"
			>{{ option }}</option>
		</select>
		<input id="baseInput" class="form-control" v-model="value.content" v-bind="$attrs">
		<mdb-btn @click.native.prevent="buttonClick" class="base-search-button btn-color-primary">Search</mdb-btn>
	</div>
</template>

<script>
import { mdbBtn } from 'mdbvue'

export default {
	inheritAttrs: false,
	data() {
		return {
			options: ['Client Email', 'Booking Number', 'Job Title', 'Job Id']
		}
	},
	props: {
		value: {
			type: Object
		},
		buttonText: {
			type: String
		},
		buttonClick: {
			type: Function
		}
	},
	methods: {
		inputValueUpdate(e) {
			let inputValue = e.target.value
			const searchParams = this.value
			searchParams.content = inputValue
			this.$emit('input', searchParams)
		},
		selectValueUpdate(e) {
			let selectValue = e.target.value
			const searchParams = this.value
			searchParams.content = selectValue
			this.$emit('input', searchParams)
		}
	},
	components: {
		mdbBtn
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/baseSearch.scss';
</style>
